var React = require('react');

function MenuShapeCircleInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"31.2441","y":"30.5576","width":"688.143","height":"688.143","rx":"344.072","stroke":"#FF00FF"}));
}

MenuShapeCircleInline.defaultProps = {"width":"750","height":"750","viewBox":"0 0 750 750","fill":"none"};

module.exports = MenuShapeCircleInline;

MenuShapeCircleInline.default = MenuShapeCircleInline;
